// `locked` is not part of the typed SlimProfile model, so it is checked at runtime.
export const isProfileLocked = (profile: unknown): boolean =>
  !!profile && typeof profile === "object" && "locked" in profile && (profile as { locked?: unknown }).locked === true;
